import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingTaskForm(props) {
  return (
    <SpaceRoleRangeForm {...props} role="repair" settingKey="repair_role_setting" />
  );
}

export default SpacesSettingTaskForm;
